// component
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const icon = (name) => <Iconify icon={name} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/',
    icon: icon('mdi:view-dashboard'),
  },
  {
    title: 'pokedex',
    path: '/pokedex',
    icon: icon('mdi:pokeball'),
  },
  {
    title: 'analytics',
    path: '/analytics',
    icon: icon('mdi:chart-box'),
  },
  {
    title: 'counters finder',
    path: '/counters-finder',
    icon: icon('mdi:sword-cross'),
  },
];

export default navConfig;
